<template>
  <div>
    <nav id="sidebar" class="sidebar--main" :class="{ active: isActive }">
      <div class="sidebar--header" ref="sidebarHeader">
        <router-link
          to="/"
          class="sidebar--brand"
          aria-label="BeliRumah Agent"
          @click.native="closeSidebar"
        >
          <img :src="agentLogoUrl" alt="BeliRumah Agent" />
        </router-link>
        <button type="button" class="sidebar--close" aria-label="Tutup sidebar" @click="setSidebar">
          <v-icon>mdi-close</v-icon>
        </button>
      </div>
      <sidebar-content :style="sidebarContentStyle"></sidebar-content>
      <div class="sidebar--footer" ref="sidebarFooter">
        <div v-if="isLoggedIn" class="sidebar--account">
          <button type="button" class="sidebar--profile" @click="goToPage('/profile')">
            <img
              v-if="user && user.photo_profile_user"
              class="sidebar--profile-picture"
              :src="user.photo_profile_user"
              :alt="profileAlt"
            />
            <span v-else class="sidebar--profile-placeholder">{{ userInitial }}</span>
            <span class="sidebar--profile-info">
              <strong>{{ displayName }}</strong>
              <span class="sidebar--membership-badge" :style="membershipStyle">
                {{ membershipLabel }}
              </span>
            </span>
          </button>
          <button type="button" class="sidebar--logout" @click="logout">
            <v-icon>mdi-logout</v-icon>
            <span>Logout</span>
          </button>
        </div>
        <div v-else class="sidebar--guest">
          <div>
            <strong>Selamat datang</strong>
            <span>Masuk untuk mengelola akun agen Anda.</span>
          </div>
          <button type="button" class="sidebar--login" @click="showLogin">Masuk / Daftar</button>
        </div>
      </div>
    </nav>
    <div class="overlay" @click="setSidebar" :class="{ active: isActive }"></div>
  </div>
</template>

<script>
import auth from '@/mixins/auth.js';
import { mapGetters, mapState } from 'vuex';

const SidebarContent = () => import('@/components/layouts/partials/sidebar-content');

export default {
  mixins: [auth],
  components: {
    SidebarContent,
  },
  data() {
    return {
      totalHeight: 0,
      agentLogoUrl:
        'https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/logo/v2/logo-agen.svg',
    };
  },
  computed: {
    ...mapState({
      sidebarContent: (state) => state.global.sidebarContent,
    }),
    ...mapGetters({
      membershipType: 'global/membershipType',
    }),
    displayName() {
      return this.user && this.user.name ? this.user.name.trim() : 'Pengguna';
    },
    profileAlt() {
      return 'Foto profil ' + this.displayName;
    },
    userInitial() {
      return this.displayName.charAt(0).toUpperCase();
    },
    membershipLabel() {
      return this.membershipType
        ? 'Membership ' + this.membershipType
        : 'Belum ada membership aktif';
    },
    membershipPalette() {
      const palettes = {
        PRO: {
          background: '#F5C04D',
          color: '#000000',
          shadow: 'rgba(245, 192, 77, 0.34)',
        },
        EXECUTIVE: {
          background: '#3B3A38',
          color: '#FFFFFF',
          shadow: 'rgba(59, 58, 56, 0.28)',
        },
        STARTER: {
          background: '#5B5C5C',
          color: '#FFFFFF',
          shadow: 'rgba(91, 92, 92, 0.28)',
        },
        LITE: {
          background: '#F92E0B',
          color: '#FFFFFF',
          shadow: 'rgba(249, 46, 11, 0.3)',
        },
      };

      return palettes[this.membershipType] || palettes.LITE;
    },
    membershipStyle() {
      return {
        background: this.membershipPalette.background,
        color: this.membershipPalette.color,
        boxShadow: '0 8px 20px ' + this.membershipPalette.shadow,
      };
    },
    sidebarContentStyle() {
      return {
        height: 'calc(100vh - ' + this.totalHeight + 'px)',
      };
    },
  },
  methods: {
    showLogin() {
      this.closeSidebar();
      this.$modal.show('modal-login');
    },
    calculateHeight() {
      if (this.$refs.sidebarHeader && this.$refs.sidebarFooter) {
        this.totalHeight =
          this.$refs.sidebarHeader.clientHeight + this.$refs.sidebarFooter.clientHeight;
      } else {
        this.totalHeight = 0;
      }
    },
    goToPage(route) {
      this.closeSidebar();
      this.$router.push(route);
    },
    async logout() {
      this.closeSidebar();
      await this.$store.dispatch('global/logout');
      this.$router.push('/login');
    },
    closeSidebar() {
      this.$store.commit('global/SET_MAIN_SIDEBAR', false);
      this.$store.commit('global/SET_SIDEBAR_CONTENT', null);
    },
    toggleSidebarBodyClass(isOpen) {
      if (typeof document === 'undefined') return;
      document.body.classList.toggle('is-agent-sidebar-open', !!isOpen);
    },
  },
  mounted() {
    this.calculateHeight();
    this.toggleSidebarBodyClass(this.isActive);
  },
  beforeDestroy() {
    this.toggleSidebarBodyClass(false);
  },
  watch: {
    isActive(isOpen) {
      this.toggleSidebarBodyClass(isOpen);
    },
    sidebarContent() {
      setTimeout(() => {
        this.calculateHeight();
      }, 250);
    },
  },
};
</script>

<style>
.overlay {
  display: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2147483646;
  top: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}

.overlay.active {
  display: block;
  opacity: 1;
}
</style>
